// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useMemo } from 'react';

import { useSession } from '@common/authorization/context/Session';
import {
  getMfaEnrollmentStatus,
  type MfaEnrollmentStatus,
} from '@common/utils/mfaEnrollment';

export const useMfaEnrollmentStatus = (): MfaEnrollmentStatus | null => {
  const { userInfo } = useSession();
  const mfaRequiredDate = userInfo?.mfaRequiredDate;
  const mfaEnrolled = userInfo?.mfaEnrolled;
  return useMemo(
    () => getMfaEnrollmentStatus(mfaRequiredDate, mfaEnrolled),
    [mfaRequiredDate, mfaEnrolled],
  );
};

export default { useMfaEnrollmentStatus };
